import { render } from "./ParcelList.vue?vue&type=template&id=185c2a3c&scoped=true"
import script from "./ParcelList.vue?vue&type=script&lang=js"
export * from "./ParcelList.vue?vue&type=script&lang=js"

import "./ParcelList.vue?vue&type=style&index=0&id=185c2a3c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185c2a3c"]])

export default __exports__